export const ACTION_SCHEDULE_LIST = 'ACTION_SCHEDULE_LIST'
export const ACTION_SCHEDULE_SET_CURRENT = 'ACTION_SCHEDULE_SET_CURRENT'
export const ACTION_SCHEDULE_LIST_FAIL = 'ACTION_SCHEDULE_LIST_FAIL'
